var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37769 21.6529C5.12669 20.5011 2 16.6157 2 12C2 6.47738 6.47691 2 12 2C17.5226 2 22 6.47738 22 12C22 16.6621 18.8094 20.5792 14.493 21.687",
    stroke: "#32C997",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3051 15.0927C15.3051 15.0927 12.2603 17.9826 8.69507 15.0927",
    stroke: "#32C997",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.688 10.6148C16.1761 10.6148 16.5714 10.2197 16.5714 9.73137C16.5714 9.24248 16.1756 8.84699 15.688 8.84699C15.2005 8.84699 14.8041 9.24291 14.8041 9.73137C14.8041 10.2193 15.1999 10.6148 15.688 10.6148Z",
    fill: "#32C997",
    stroke: "#32C997",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31164 10.6148C8.79977 10.6148 9.19508 10.2197 9.19508 9.73137C9.19508 9.24248 8.79921 8.84699 8.31164 8.84699C7.82413 8.84699 7.42773 9.24291 7.42773 9.73137C7.42773 10.2193 7.82356 10.6148 8.31164 10.6148Z",
    fill: "#32C997",
    stroke: "#32C997",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappy);
export default __webpack_public_path__ + "static/media/face-happy.5e4baa125052e0767e457c29c1ef58f4.svg";
export { ForwardRef as ReactComponent };